module.exports = __webpack_public_path__ + "static/img/6.b1ce561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/premedical/6.png
// module id = 6+wh
// module chunks = 1